import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';

@Component({
  selector: 'app-view-lab-results-history',
  templateUrl: './view-lab-results-history.component.html',
  styleUrls: ['./view-lab-results-history.component.scss']
})
export class ViewLabResultsHistoryComponent implements OnInit {
  images = []
  latestImage = {};

  pageSize = 1;
  pageIndex = 0;
  constructor(
    public dialogRef: MatDialogRef<ViewLabResultsHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private evaluatorService: EvaluatorService
  ) { }

  ngOnInit(): void {
    this.evaluatorService.getLabHistory(this.data.applicationId).subscribe(res => {
      const filtered = res.filter(x => x.resultTypeValue == this.data.resultTypeValue)
      filtered.forEach(element => {
        if (element.fileDetails.length > 0) {
          this.images.push(
            {
              date: element.uploadedDate,
              path: element.fileDetails[0].fullPath,
            }
          )
        }
      });
      if (this.images.length > 0) {
        this.latestImage = this.images[this.images.length - 1].path;
      }


    })
  }

  handlePage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

}
